<select [(ngModel)]="value" data-cy="selectAdjustmentTypeSelector" class="form-control" (blur)="onBlur()" (ngModelChange)="modelChange($event)">
  <option
    *ngFor="let adjustmentType of adjustmentTypes"
    [value]="adjustmentType.AdjustmentTypeId"
    [selected]="adjustmentType.AdjustmentTypeId == value ? true : null"
  >
    {{ adjustmentType.AdjustmentType }}
  </option>
</select>
